import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundInvoice.Find.IRequest;
type Response = Api.Sales.ContractRefundInvoice.Find.IResponse;
type Headers = Api.Sales.ContractRefundInvoice.Find.IHeaders;
const url = '/api/Sales/ContractRefundInvoice/:id';
export default async function contractRefundInvoiceFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
